import { variantOf } from '../lib/products';

const PackImg = ({ f, variant = '50g', className = '', testid }) => {
  const v = variantOf(variant);
  return (
    <img
      src={f[v.img]}
      alt={`PROKRISP ${f.name} ${v.sub}`}
      data-testid={testid}
      loading="lazy"
      className={`object-contain gpu ${className}`}
      draggable="false"
    />
  );
};

export default PackImg;
